import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { getOtp } from '../api';
import { gotoTarget } from '../redirects';

// /Goto/:url (url = btoa(app url)): sends the signed-in user back to the app with ?otp=, which the app exchanges at
// POST /jwt/exchange for the identity JWT.
export const Goto: React.FC = () => {
    const { url = '' } = useParams();
    const target = gotoTarget(url);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!target) return;
        getOtp()
            .then(otp => {
                target.searchParams.append('otp', otp);
                window.location.href = target.toString();
            })
            .catch((e: Error) => setError(e.message));
    }, [url]);

    if (!target) {
        return <Box className="center"><Typography color="error">Not a company app address, not redirecting.</Typography></Box>;
    }
    if (error) {
        return <Box className="center"><Typography color="error">{error}</Typography></Box>;
    }
    return (
        <Box className="center">
            <Typography>
                You are logged in successfully. Click <a href={target.toString()}>here</a> if your browser is not redirected.
            </Typography>
        </Box>
    );
};
